export default "__VITE_ASSET__2a419df4__"